exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "a.sidebar-link:hover{text-decoration:none}a.sidebar-link button.sidebar-btn-padding{padding:1px 8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Common/SideBarCard/SideBarCard.scss
// module id = 7524
// module chunks = 101